import type { IDisposable } from "./disposable.interface";
import type { ISimpleEvent } from "./isimple-event";

export interface SimpleListener {
  (): void;
}

export class SimpleEvent implements ISimpleEvent {
  private listeners: SimpleListener[] = [];
  private onceListeners: SimpleListener[] = [];

  on(listener: SimpleListener): IDisposable {
    this.listeners.push(listener);

    return {
      dispose: () => this.removeListener(listener),
    };
  }

  once(listener: SimpleListener): void {
    this.onceListeners.push(listener);
  }

  removeListener(listener: SimpleListener): void {
    const callbackIndex = this.listeners.indexOf(listener);

    if (callbackIndex > -1) this.listeners.splice(callbackIndex, 1);
  }

  removeAllListeners(): void {
    this.listeners.splice(0, this.listeners.length);
    this.onceListeners.splice(0, this.onceListeners.length);
  }

  // Not part of the interface:
  // Because clients that register listeners should never be able to emit!
  emit(): void {
    /** Update any general listeners */
    Array.from(this.listeners).forEach((listener) => listener());

    /** Clear the `once` queue */
    if (this.onceListeners.length > 0) {
      const toCall = this.onceListeners;
      this.onceListeners = [];
      toCall.forEach((listener) => listener());
    }
  }
}
